export enum EStorageKey {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  TEMPORARY_TOKEN = "TEMPORARY_TOKEN",
}
